import { Link } from "react-router-dom";
import { Building2, Truck, PackageCheck, Users2, ArrowUpRight, CheckCircle2 } from "lucide-react";

const BENEFITS = [
  { icon: Building2, t: "B2B Selling Ecosystem", d: "Tap into India's largest organised B2B distribution & marketplace fulfilment partner." },
  { icon: Truck, t: "Marketplace Fulfilment", d: "Inbound, storage, picking and last-mile across Amazon, Flipkart, JioMart networks." },
  { icon: PackageCheck, t: "Distribution Reach", d: "20+ cities, multiple fulfilment centers, integrated returns and reverse logistics." },
  { icon: Users2, t: "Seller Support Ecosystem", d: "End-to-end ops, cataloging, pricing, and growth — managed under one roof." },
];

export default function CocobluSection() {
  return (
    <section
      data-testid="cocoblu-section"
      className="border-y-2 border-black bg-black py-20 text-white md:py-24"
    >
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid gap-12 md:grid-cols-12 md:items-center">
          <div className="md:col-span-6">
            <div className="inline-block border-2 border-[#FFD700] bg-[#FFD700] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.25em] text-black">
              Partner Spotlight
            </div>
            <h2 className="display mt-5 text-4xl font-black leading-[0.95] tracking-tight md:text-5xl lg:text-6xl">
              Powered alongside<br />
              <span className="border-b-4 border-[#FFD700]">Cocoblu Retail.</span>
            </h2>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-white/80 md:text-lg">
              For brands ready to scale beyond direct marketplace seller accounts, we partner with Cocoblu — one of India's largest organised B2B distribution & marketplace fulfilment players. The result: predictable inbound, deep marketplace integrations, and serious reach.
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link to="/contact/?type=cocoblu" className="btn-brutal dark" data-testid="cocoblu-cta-onboard">
                Get Onboarded on Cocoblu <ArrowUpRight size={16} />
              </Link>
            </div>
          </div>

          <div className="md:col-span-6">
            <div className="grid grid-cols-1 gap-0 sm:grid-cols-2">
              {BENEFITS.map((b, i) => (
                <div
                  key={b.t}
                  data-testid={`cocoblu-benefit-${i}`}
                  className="-ml-[2px] -mt-[2px] flex flex-col gap-3 border-2 border-[#FFD700]/40 bg-black p-6 transition-colors hover:bg-[#FFD700] hover:text-black"
                >
                  <div className="flex h-10 w-10 items-center justify-center border-2 border-[#FFD700] bg-[#FFD700] text-black">
                    <b.icon size={18} />
                  </div>
                  <h3 className="display text-lg font-black">{b.t}</h3>
                  <p className="text-sm leading-relaxed text-white/75 group-hover:text-black/80">{b.d}</p>
                </div>
              ))}
            </div>

            <div className="mt-6 border-2 border-[#FFD700]/40 bg-[#FFD700]/5 p-5">
              <div className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-widest text-[#FFD700]">
                <CheckCircle2 size={14} /> What you get with the Orina + Cocoblu stack
              </div>
              <ul className="mt-3 grid grid-cols-1 gap-2 text-sm text-white/85 sm:grid-cols-2">
                <li className="flex items-start gap-2"><span className="mt-1 h-1.5 w-1.5 shrink-0 bg-[#FFD700]" /> One contract, multi-marketplace launch</li>
                <li className="flex items-start gap-2"><span className="mt-1 h-1.5 w-1.5 shrink-0 bg-[#FFD700]" /> Inventory + fulfilment in one place</li>
                <li className="flex items-start gap-2"><span className="mt-1 h-1.5 w-1.5 shrink-0 bg-[#FFD700]" /> Direct category-manager relationships</li>
                <li className="flex items-start gap-2"><span className="mt-1 h-1.5 w-1.5 shrink-0 bg-[#FFD700]" /> Festive deal & banner placements</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
